export default __webpack_public_path__ + "static/gb-wls-523642e50f27fa8f139d2a24db6664f6.svg";